module.exports = __webpack_public_path__ + "img/filled-dowload.8395d54b.svg";